import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Page404 from '../../components/Page404';
import StoreList from './StoreList';
import Store from './Store';

const StoreRoute = () => {
  const { url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`/Stores/StoreList`} component={StoreList} />
      <Route exact path={`/Stores/Store/:id?`} component={Store} />
      <Route component={Page404} />
    </Switch>
  );
};

export default StoreRoute;
